<template>
  <div class="tw-flex-1 tw-flex tw-h-full tw-w-full">
    <div
      ref="mobileRoot"
      class="contents-insurance-tooltip tw-relative tw-rounded-[16px] tw-shadow-lg tw-w-full md:tw-hidden"
    >
      <div
        class="insurance-banner insurance-banner--filled-corner tw-relative tw-flex tw-h-full tw-min-h-[110px] tw-overflow-hidden tw-rounded-[16px] tw-border-0 tw-shadow-lg xs2:tw-min-h-[130px]"
      >
        <div class="insurance-banner__panel" aria-hidden="true"></div>
        <div
          class="insurance-banner__copy tw-flex tw-flex-1 tw-w-full tw-items-start tw-px-[16px] tw-py-[18px] !tw-pr-[118px] xs2:!tw-pr-[16px] xs:!tw-pr-[80px] "
        >
          <p
            class="tw-font-inter tw-mb-0 tw-text-left tw-font-normal tw-text-white max-[576px]:tw-text-[16px] max-[576px]:tw-leading-[24px] min-[577px]:tw-text-[22px] min-[577px]:tw-leading-[33px]"
          >
            <span class="tw-font-bold">FREE Contents Insurance</span> included with every UniHomes utilities package
            <button
              ref="mobileToggle"
              type="button"
              class="tw-inline-flex tw-h-[20px] tw-w-[20px] tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-align-middle"
              aria-label="Show contents insurance information"
              :aria-expanded="showMobileTooltip ? 'true' : 'false'"
              @click.stop="toggleMobileTooltip"
            >
              <img
                :src="cdnAsset('svg/uh-info-icon-white.svg')"
                alt=""
                class="tw-h-[20px] tw-w-[20px]"
                aria-hidden="true"
              />
            </button>
          </p>
        </div>
        <div
          class="insurance-banner__art tw-absolute tw-bottom-0 tw-right-0 tw-h-full tw-w-[124px] tw-overflow-visible"
        >
          <div
            class="insurance-banner__visual-shell tw-absolute tw-bottom-[-18px] tw-right-[-18px] tw-h-[96px] tw-w-[96px] tw-overflow-visible"
          >
            <span
              class="free-badge tw-absolute tw-left-[-8px] tw-top-[-3px] tw-z-[2] tw-inline-flex tw-h-[27px] tw-w-[48px] tw-items-center tw-justify-center tw-rounded-[12px] tw-text-[12px] tw-font-[800] tw-leading-[18.72px] tw-text-white"
            >
              FREE
            </span>
            <div
              class="insurance-banner__visual tw-flex tw-h-[96px] tw-w-[96px] tw-items-end tw-justify-end tw-overflow-hidden tw-rounded-r-[16px]"
            >
              <div
                class="insurance-banner__halo tw-flex tw-h-[96px] tw-w-[96px] tw-items-end tw-justify-end tw-rounded-full"
              >
                <div
                  class="insurance-banner__circle tw-mb-[12px] tw-mr-[12px] tw-flex tw-h-[74px] tw-w-[74px] tw-items-center tw-justify-center tw-rounded-full"
                >
                  <img
                    :src="cdnAsset('svg/uh-shield-check-icon-clean.svg')"
                    alt="Contents insurance shield"
                    class="insurance-banner__shield tw-h-[48px] tw-w-[48px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="showMobileTooltip"
        ref="mobilePanel"
        class="tw-absolute tw-z-[10]"
        :style="mobileTooltipStyle"
      >
        <div
          class="tw-relative tw-rounded-[8px] tw-bg-[#3B4143] tw-p-[8px] tw-shadow-[0_4px_24px_0_rgba(0,0,0,0.40)]"
        >
          <p
            class="tw-font-inter tw-mb-0 tw-text-left tw-text-[16px] tw-font-[400] tw-leading-[24px] tw-text-white"
          >
            Provided alongside your UniHomes utilities package at no additional
            cost to you.
          </p>
          <span
            class="tw-absolute tw-bottom-[-6px] tw-h-[12px] tw-w-[12px] -tw-translate-x-1/2 tw-rotate-45 tw-bg-[#3B4143]"
            :style="{
              left: 'var(--contents-insurance-tooltip-arrow-left, 50%)',
            }"
          ></span>
        </div>
      </div>
    </div>

    <ContentsInsurancePromoDesktopTile
      :city-name="headlineCityName"
    ></ContentsInsurancePromoDesktopTile>
  </div>
</template>

<script>
import ContentsInsurancePromoDesktopTile from '@components/properties-search/components/ContentsInsurancePromoDesktopTile.vue';

export default {
  name: 'ContentsInsurancePromoCard',
  components: {
    ContentsInsurancePromoDesktopTile,
  },
  props: {
    cityName: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      mobileTooltipStyle: {},
      showMobileTooltip: false,
    };
  },
  computed: {
    headlineCityName() {
      return this.cityName || 'this city';
    },
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleEscapeKey);
    window.addEventListener('resize', this.updateMobileTooltipPosition);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleEscapeKey);
    window.removeEventListener('resize', this.updateMobileTooltipPosition);
  },
  methods: {
    closeMobileTooltip() {
      this.showMobileTooltip = false;
    },
    handleDocumentClick(event) {
      if (!this.showMobileTooltip) {
        return;
      }

      if (!this.$refs.mobileRoot?.contains(event.target)) {
        this.closeMobileTooltip();
      }
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape') {
        this.closeMobileTooltip();
      }
    },
    toggleMobileTooltip() {
      this.showMobileTooltip = !this.showMobileTooltip;

      if (this.showMobileTooltip) {
        this.$nextTick(this.updateMobileTooltipPosition);
      }
    },
    updateMobileTooltipPosition() {
      if (
        !this.showMobileTooltip ||
        !this.$refs.mobileRoot ||
        !this.$refs.mobileToggle ||
        !this.$refs.mobilePanel
      ) {
        return;
      }

      const rootRect = this.$refs.mobileRoot.getBoundingClientRect();
      const toggleRect = this.$refs.mobileToggle.getBoundingClientRect();
      const panel = this.$refs.mobilePanel;
      const horizontalGutter = 16;
      const tooltipGap = 12;
      const arrowPadding = 32;
      const targetWidth = Math.max(window.innerWidth - horizontalGutter * 2, 0);

      panel.style.width = `${targetWidth}px`;
      const panelRect = panel.getBoundingClientRect();
      const toggleCenter = toggleRect.left + toggleRect.width / 2;
      const panelLeft = Math.min(
        Math.max(toggleCenter - panelRect.width / 2, horizontalGutter),
        Math.max(
          horizontalGutter,
          window.innerWidth - panelRect.width - horizontalGutter
        )
      );
      const panelTop =
        toggleRect.top - rootRect.top - panelRect.height - tooltipGap;
      const arrowLeft = Math.min(
        Math.max(toggleCenter - panelLeft, arrowPadding),
        panelRect.width - arrowPadding
      );

      this.mobileTooltipStyle = {
        '--contents-insurance-tooltip-arrow-left': `${arrowLeft}px`,
        left: `${panelLeft - rootRect.left}px`,
        top: `${panelTop}px`,
        width: `${targetWidth}px`,
      };
    },
  },
};
</script>
